import { useTranslation } from 'react-i18next';
import { brand } from 'src/shared/branding/brand';
import { SmsConsentNoteWrapper } from './SmsConsentNote.style';

interface SmsConsentNoteProps {
  /**
   * The id of the checkbox this line belongs to. When set, the consent text
   * becomes that checkbox's label: a click on the text toggles the box, and a
   * screen reader reads the text as the box's name. The links stay outside
   * the label, so a click on a link only opens the link.
   */
  labelFor?: string;
}

/**
 * The text-message consent line shown directly under (or beside) the "Text
 * message" checkbox. The brand name comes from the i18n {{brandName}} variable
 * and the Terms and Privacy links come from the brand config, so the line
 * changes with the brand.
 */
export const SmsConsentNote = ({ labelFor }: SmsConsentNoteProps) => {
  const { t } = useTranslation();
  const text = t('notifications.modal.smsConsent.text');
  return (
    <SmsConsentNoteWrapper>
      <p>
        {labelFor ? <label htmlFor={labelFor}>{text}</label> : text}{' '}
        <a href={brand.termsUrl} target="_blank" rel="noopener noreferrer">
          {t('notifications.modal.smsConsent.termsLink')}
        </a>
        {' · '}
        <a href={brand.privacyUrl} target="_blank" rel="noopener noreferrer">
          {t('notifications.modal.smsConsent.privacyLink')}
        </a>
      </p>
    </SmsConsentNoteWrapper>
  );
};
